import { parseCookie } from "./cookie";
import { Guid } from "./guid";

// Shopify stopped setting _shopify_y / _shopify_s on storefronts on 2026-01-01,
// so the anonymous id is kept in our own first-party storage.
// The key and the resolution order must stay in sync with
// theme/assets/customers-canvas-storefront-init.js and theme/snippets/cc-onlogin.liquid.
const STORAGE_KEY = "cc_anonymous_id";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
const LEGACY_COOKIES = ["_shopify_y", "_y", "_shopify_s", "_s", "__ssid"];

let inMemoryId: string | null = null;

export function getAnonymousId(): string {
    const cookie = parseCookie(document.cookie) as Record<string, string>;

    const id = readLocalStorage()
        || cookie[STORAGE_KEY]
        || inMemoryId
        || LEGACY_COOKIES.map(name => cookie[name]).find(value => !!value)
        || Guid.new();

    persist(id);

    return id;
}

function readLocalStorage(): string | null {
    try {
        return window.localStorage.getItem(STORAGE_KEY);
    }
    catch {
        return null;
    }
}

function persist(id: string) {
    inMemoryId = id;

    try {
        window.localStorage.setItem(STORAGE_KEY, id);
    }
    catch { }

    document.cookie = `${STORAGE_KEY}=${id}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
}
